<ng-container *ngIf="(reviewCode && talent.reviewCodes.includes(reviewCode)) && (talent.reviewStatus == ReviewStatus.WaitingForReview)">
  <mat-icon class="status-icon warning">visibility</mat-icon>
</ng-container>
<ng-container *ngIf="(!reviewCode) && (talent.reviewStatus == ReviewStatus.WaitingForReview)">
  <mat-icon class="status-icon warning">visibility</mat-icon>
</ng-container>
<ng-container *ngIf="(!reviewCode) && (talent.reviewStatus == ReviewStatus.Reviewed)">
  <mat-icon class="status-icon done">done</mat-icon>
</ng-container>